/**
 * `/profile` — kept as a redirect to the new home at `/settings/profile`.
 *
 * Profile moved into the settings rail (rail position #1, "Account"
 * group) so every self-serve preference lives in one place. The redirect
 * keeps any bookmarks / in-app links pointing at the old URL working.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(workspace)/profile/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/profile" });
  },
});
